import React from 'react';
import './Divider.css';

export interface DividerProps {
  /** Whether to use the accent color instead of border color */
  accent?: boolean;
  /** Vertical margin (spacing above and below) */
  margin?: 'sm' | 'md' | 'lg' | 'xl';
  /** Additional CSS classes */
  className?: string;
  /** Optional ID for styling or testing */
  id?: string;
}

/**
 * Simple, elegant divider component with fade-in animation.
 * Perfect for visual separation between sections.
 *
 * @example
 * <SectionHeading heading="Section One" />
 * <p>Content here</p>
 *
 * <Divider margin="lg" />
 *
 * <SectionHeading heading="Section Two" />
 * <p>More content</p>
 *
 * <Divider accent margin="xl" />
 */
export const Divider: React.FC<DividerProps> = ({
  accent = false,
  margin = 'lg',
  className = '',
  id,
}) => {
  return (
    <div
      id={id}
      className={`divider divider--margin-${margin} ${
        accent ? 'divider--accent' : ''
      } ${className}`}
      role="presentation"
      aria-hidden="true"
    />
  );
};

Divider.displayName = 'Divider';
